/* ==========================================================================
   wk-set-conseille.js — Widget « Produits fréquemment achetés ensemble »

   - recalcule le total selon les cases cochees et les variantes choisies
   - suit le selecteur de variante de la fiche pour la carte du produit courant
   - ajoute tous les articles coches au panier en un seul appel /cart/add.js

   Club Welkit :
     - membre     -> le total est calcule sur les prix club
     - non-membre -> total standard + ligne d'incitation (total club + economie)
     - B2B natif  -> aucun affichage club (data-club-bloque)
   Aucune remise de lot : les montants sont les prix courants, la Function
   applique le tarif club au panier.

   Les prix des cartes sont remplaces par les chaines formatees cote Liquid
   (`price-as-money`) pour rester identiques au reste du theme. Seuls les
   totaux du recapitulatif sont formates en JS (Intl).
   ========================================================================== */

(function () {
  'use strict';

  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = RACINE.replace(/\/$/, '');
  var URL_AJOUT = (window.routes && window.routes.cart_add_url) || BASE + '/cart/add.js';
  var URL_PANIER = (window.routes && window.routes.cart_url) || BASE + '/cart';

  function argent(centimes, devise) {
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: devise || 'EUR'
      }).format(centimes / 100);
    } catch (e) {
      return (centimes / 100).toFixed(2).replace('.', ',') + ' \u20AC';
    }
  }

  function SetConseille(racine) {
    this.racine = racine;
    this.devise = racine.dataset.devise || 'EUR';
    this.francoSeuil = parseInt(racine.dataset.francoSeuil, 10) || 0;
    this.membre = racine.dataset.clubMembre === 'true';
    this.clubBloque = racine.dataset.clubBloque === 'true';

    this.elTotal = racine.querySelector('[data-wk-set-total]');
    this.elWas = racine.querySelector('[data-wk-set-was]');
    this.elLivraison = racine.querySelector('[data-wk-set-livraison]');
    this.elClub = racine.querySelector('[data-wk-set-club]');
    this.elClubAmount = racine.querySelector('[data-wk-set-club-amount]');
    this.elClubEco = racine.querySelector('[data-wk-set-club-eco]');
    this.elClubDetail = racine.querySelector('[data-wk-set-club-detail]');
    this.elBouton = racine.querySelector('[data-wk-set-ajouter]');
    this.elLibelle = racine.querySelector('.wk-set__cta-label');
    this.elErreur = racine.querySelector('[data-wk-set-erreur]');

    var self = this;
    this.cartes = [];
    racine.querySelectorAll('[data-wk-set-carte]').forEach(function (el) {
      var carte = self.lireCarte(el);
      if (carte) self.cartes.push(carte);
    });

    if (!this.cartes.length) return;

    this.brancher();
    this.synchroniserFiche();
    this.rafraichir();
  }

  /* ---- Lecture d'une carte ---------------------------------------------- */

  SetConseille.prototype.lireCarte = function (el) {
    var script = el.querySelector('[data-wk-set-variantes]');
    if (!script) return null;

    var variantes;
    try {
      variantes = JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
    if (!Array.isArray(variantes) || !variantes.length) return null;

    var select = el.querySelector('[data-wk-set-select]');
    var choisie = select ? this.trouverVariante(variantes, parseInt(select.value, 10)) : null;

    if (!choisie) {
      choisie = variantes.filter(function (v) {
        return v.dispo;
      })[0];
    }
    if (!choisie) return null;

    var zonePrix = el.querySelector('[data-wk-set-prix]');

    return {
      el: el,
      principal: el.dataset.principal === 'true',
      clubPrive: el.dataset.clubPrive === 'true',
      variantes: variantes,
      variante: choisie,
      coche: el.querySelector('[data-wk-set-coche]'),
      select: select,
      elImage: el.querySelector('[data-wk-set-image] img'),
      // .price__current / .price__was sont le markup natif du theme :
      // on remplace uniquement la valeur, jamais la structure.
      elPrix: zonePrix ? zonePrix.querySelector('.price__current .js-value') : null,
      elWas: zonePrix ? zonePrix.querySelector('.price__was .js-value') : null,
      elClub: zonePrix ? zonePrix.querySelector('.price__club-amount') : null
    };
  };

  SetConseille.prototype.trouverVariante = function (variantes, id) {
    if (!id) return null;
    for (var i = 0; i < variantes.length; i++) {
      if (variantes[i].id === id) return variantes[i];
    }
    return null;
  };

  /* ---- Evenements -------------------------------------------------------- */

  SetConseille.prototype.brancher = function () {
    var self = this;

    this.cartes.forEach(function (carte) {
      if (carte.coche) {
        carte.coche.addEventListener('change', function () {
          self.rafraichir();
        });
      }
      if (carte.select) {
        carte.select.addEventListener('change', function () {
          var v = self.trouverVariante(carte.variantes, parseInt(carte.select.value, 10));
          if (v) carte.variante = v;
          self.rafraichir();
        });
      }
    });

    if (this.elBouton) {
      this.elBouton.addEventListener('click', function () {
        self.ajouterAuPanier();
      });
    }
  };

  /* ---- Synchronisation avec le selecteur de variante de la fiche ---------
     Si le formulaire produit expose un input [name="id"], la carte du produit
     courant suit ce choix et masque son propre selecteur. Sinon le widget
     reste autonome : pas de casse, juste un selecteur en double.
  ------------------------------------------------------------------------ */

  SetConseille.prototype.synchroniserFiche = function () {
    var principal = this.cartes.filter(function (c) {
      return c.principal;
    })[0];
    if (!principal) return;

    var input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], product-form input[name="id"]'
    );
    if (!input) return;

    var self = this;

    function appliquer() {
      var v = self.trouverVariante(principal.variantes, parseInt(input.value, 10));
      if (!v) return;
      principal.variante = v;
      if (principal.select) principal.select.value = String(v.id);
      self.rafraichir();
    }

    input.addEventListener('change', appliquer);

    if (window.MutationObserver) {
      new MutationObserver(appliquer).observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    var conteneur = principal.el.querySelector('.wk-set__variant');
    if (conteneur) conteneur.hidden = true;

    appliquer();
  };

  /* ---- Recalcul ---------------------------------------------------------- */

  SetConseille.prototype.rafraichir = function () {
    var totalStandard = 0;
    var totalClub = 0;
    var totalBarre = 0;
    var nbCoches = 0;
    var clubDispo = false;
    var clubMasque = false;
    var self = this;

    this.cartes.forEach(function (carte) {
      var v = carte.variante;
      var actif = !carte.coche || carte.coche.checked;

      // Vue MEMBRE : price.liquid met le prix club dans .price__current et le
      // prix standard dans .price__was. On respecte cette repartition, sinon
      // on reecrit des prix standard par-dessus l'affichage club.
      var vueClub = self.membre && v.club > 0;

      if (carte.elPrix) carte.elPrix.textContent = vueClub ? v.club_fmt : v.prix_fmt;

      if (carte.elWas) {
        if (v.barre > v.prix) {
          carte.elWas.textContent = v.barre_fmt;
        } else if (vueClub) {
          carte.elWas.textContent = v.prix_court;
        } else {
          carte.elWas.textContent = '';
        }
      }

      if (carte.elClub) carte.elClub.textContent = v.club > 0 ? v.club_court : '';

      // Image de la variante. srcset est vide en premier : sinon le navigateur
      // continue de servir l'ancienne source malgre le changement de src.
      if (carte.elImage && v.image && carte.elImage.getAttribute('src') !== v.image) {
        carte.elImage.removeAttribute('srcset');
        carte.elImage.removeAttribute('sizes');
        carte.elImage.setAttribute('src', v.image);
      }

      carte.el.classList.toggle('wk-set__card--off', !actif);
      if (!actif) return;

      nbCoches += 1;
      totalStandard += v.prix;
      totalClub += v.club > 0 ? v.club : v.prix;
      totalBarre += v.barre > v.prix ? v.barre : v.prix;

      if (v.club > 0) {
        clubDispo = true;
        if (carte.clubPrive) clubMasque = true;
      }
    });

    var totalPaye = this.membre ? totalClub : totalStandard;

    if (this.elTotal) this.elTotal.textContent = argent(totalPaye, this.devise);

    if (this.elWas) {
      if (totalBarre > totalPaye) {
        this.elWas.textContent = argent(totalBarre, this.devise);
        this.elWas.hidden = false;
      } else {
        this.elWas.hidden = true;
      }
    }

    if (this.elClub) {
      if (clubDispo && this.membre) {
        // Membre : seul le gain a du sens, le prix club est deja le total.
        if (this.elClubEco) {
          this.elClubEco.textContent = argent(totalStandard - totalClub, this.devise);
        }
        this.elClub.hidden = totalStandard <= totalClub;
      } else if (clubDispo && !this.membre && !this.clubBloque) {
        if (clubMasque) {
          this.elClubAmount.textContent = 'R\u00E9serv\u00E9 aux membres';
          if (this.elClubDetail) this.elClubDetail.hidden = true;
        } else {
          this.elClubAmount.textContent = argent(totalClub, this.devise);
          if (this.elClubEco) {
            this.elClubEco.textContent = argent(totalStandard - totalClub, this.devise);
          }
          if (this.elClubDetail) this.elClubDetail.hidden = false;
        }
        this.elClub.hidden = false;
      } else {
        this.elClub.hidden = true;
      }
    }

    if (this.elLivraison) {
      if (!this.francoSeuil) {
        this.elLivraison.textContent = '';
      } else if (totalPaye >= this.francoSeuil) {
        this.elLivraison.textContent = 'Livraison offerte \u00B7 Exp\u00E9di\u00E9 le jour m\u00EAme';
      } else {
        this.elLivraison.textContent =
          'Plus que ' +
          argent(this.francoSeuil - totalPaye, this.devise) +
          ' pour la livraison offerte \u00B7 Exp\u00E9di\u00E9 le jour m\u00EAme';
      }
    }

    if (this.elBouton) this.elBouton.disabled = nbCoches === 0;
    this.majLibelle(nbCoches);
  };

  /* Libelle du bouton : « Ajouter les 4 produits au panier », et singulier a 1. */
  SetConseille.prototype.majLibelle = function (n) {
    if (!this.elLibelle) return;
    if (n === undefined) {
      n = this.cartes.filter(function (c) {
        return !c.coche || c.coche.checked;
      }).length;
    }
    this.elLibelle.textContent =
      n > 1 ? 'Ajouter les ' + n + ' produits au panier' : 'Ajouter le produit au panier';
  };

  /* ---- Ajout au panier --------------------------------------------------- */

  SetConseille.prototype.ajouterAuPanier = function () {
    var self = this;
    var articles = this.cartes
      .filter(function (c) {
        return !c.coche || c.coche.checked;
      })
      .map(function (c) {
        return { id: c.variante.id, quantity: 1 };
      });

    if (!articles.length) return;

    this.elBouton.disabled = true;
    this.elBouton.setAttribute('aria-busy', 'true');
    if (this.elLibelle) this.elLibelle.textContent = 'Ajout en cours\u2026';
    if (this.elErreur) this.elErreur.hidden = true;

    fetch(URL_AJOUT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: articles })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Ajout impossible.');
          return data;
        });
      })
      .then(function () {
        window.location.href = URL_PANIER;
      })
      .catch(function (err) {
        self.elBouton.disabled = false;
        self.elBouton.removeAttribute('aria-busy');
        self.majLibelle();
        if (self.elErreur) {
          self.elErreur.textContent =
            err.message || 'Un article du set n\u2019est plus disponible. Merci de r\u00E9essayer.';
          self.elErreur.hidden = false;
        }
      });
  };

  /* ---- Initialisation ---------------------------------------------------- */

  function init() {
    document.querySelectorAll('[data-wk-set]').forEach(function (el) {
      if (el.dataset.wkSetPret === '1') return;
      el.dataset.wkSetPret = '1';
      new SetConseille(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
